webpackJsonp([1],{

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Matrix__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Matrix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Matrix__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'game',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Matrix___default.a
  }, {
    path: '/hello',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(84),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js sfsfsfs'
    };
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'matrix',
  components: {},
  props: {
    shouldRemoveEmptyRow: {
      type: Boolean,
      default: true
    },
    shouldStartWithRandoms: {
      type: Boolean,
      default: false
    },
    colsN: {
      type: Number,
      default: 10
    },
    rowsN: {
      type: Number,
      default: 16
    },
    targetSum: {
      type: Number,
      default: 10
    },
    sequence: {
      type: Array,
      default: function _default() {
        return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 0, 0, 1, 0, 2, 0, 3, 0, 4];
      }
    }
  },
  data: function data() {
    return {
      chained: [],
      matrix: this.fill([], this.shouldStartWithRandoms ? this.generate(this.sequence.length * 2) : this.sequence)
    };
  },

  computed: {
    curSequence: function curSequence() {
      var _this = this;

      return this.matrix.reduce(function (all, row) {
        return all.concat(row.filter(function (col) {
          return _this.isAlive(col);
        }));
      }, []);
    }
  },
  watch: {
    matrix: function matrix() {
      if (!this.hasSpace()) {
        this.onGameOver();
      }
    },
    curSequence: function curSequence(value) {
      if (value.length < 1) {
        this.onGameWon();
      }
    },
    chained: function chained(value) {
      if (value.length > 1) {
        this.onChained();
      }
    }
  },
  methods: {
    onChoose: function onChoose(coord) {
      if (!this.isCell(coord)) {
        return;
      }

      if (this.isChained(coord)) {
        this.toggle('off', coord);
      } else {
        this.toggle('on', coord);
      }
    },
    onChained: function onChained() {
      if (this.chained.length < 2) {
        return;
      }

      var _chained = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(this.chained, 2),
          left = _chained[0],
          right = _chained[1];

      if (this.isChainablePair(left, right)) {
        var one = this.getCell(left);
        var two = this.getCell(right);
        if (one === two || one + two === this.targetSum) {
          // chained indeed
          this.destroy.apply(this, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.chained));
          return;
        }
      }

      // keep only last then
      this.chained.splice(0, this.chained.length - 1);
    },
    onNext: function onNext() {
      this.chained = [];
      this.reproduce();
    },
    onRestart: function onRestart() {
      // just reset whole data
      // thx to https://github.com/vuejs/vue/issues/702#issuecomment-308991548
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.apply(this));
    },
    onGameWon: function onGameWon() {
      alert('WIN!');
    },
    onGameOver: function onGameOver() {
      alert('FINITA!');
    },
    clsCell: function clsCell(coord) {
      var isDigit = this.isCell(coord);
      var isClean = !isDigit && this.isCleared(coord);
      var isEmpty = !isDigit && !isClean;
      var isActive = !isEmpty && this.isChained(coord);
      return {
        'is-digit': isDigit,
        'is-clean': isClean,
        'is-empty': isEmpty,
        'is-active': isActive
      };
    },
    generate: function generate(n) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Array(n))).map(function (x) {
        return Math.min(9, Math.floor(Math.random() * 10));
      });
    },
    toggle: function toggle(onOff) {
      for (var _len = arguments.length, coords = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        coords[_key - 1] = arguments[_key];
      }

      if (!this.chained.length) {
        var _chained2;

        // short version
        onOff !== 'off' && (_chained2 = this.chained).push.apply(_chained2, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(coords));
        return this;
      }

      var chained = this.chained.slice();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(coords), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var coord = _step.value;

          var index = chained.findIndex(this._chainedMatcher(coord));
          if (~index && onOff !== 'on') {
            chained.splice(index, 1);
          } else if (!~index && onOff !== 'off') {
            chained.push(coord);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.chained = chained;
      return this;
    },
    process: function process() {
      for (var _len2 = arguments.length, coords = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        coords[_key2] = arguments[_key2];
      }

      this.destroy.apply(this, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(coords.length ? coords : this.chained));
      return this;
    },
    destroy: function destroy() {
      var _this2 = this;

      for (var _len3 = arguments.length, coords = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        coords[_key3] = arguments[_key3];
      }

      this.toggle.apply(this, ['off'].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(coords)));

      this.matrix = this.matrix.map(function (row, idx) {
        var seq = row.slice();

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(coords), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref = _step2.value;

            var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

            var _row = _ref2[0];
            var col = _ref2[1];

            if (_row === idx && _this2.isAlive(seq[col])) {
              seq[col] = null;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (_this2.shouldRemoveEmptyRow && seq.every(function (cell) {
          return cell === null;
        })) {
          // remove this row
          return undefined;
        }

        return seq;
      }).filter(Boolean);

      return this;
    },
    reproduce: function reproduce() {
      this.matrix = this.fill(this.clone());
      return this;
    },
    clone: function clone() {
      var matrix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.matrix;

      return Array.isArray(matrix) ? matrix.map(function (row) {
        return row.slice();
      }) : [];
    },
    fill: function fill(matrix) {
      var sequence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.curSequence;
      var colsN = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.colsN;
      var rowsN = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.rowsN;

      if (!matrix.length) {
        // we need at least one row to start
        matrix.push([]);
      }

      var currentRow = matrix.length - 1;
      var currentCol = matrix[currentRow].length;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(sequence), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var cell = _step3.value;

          if (currentCol < colsN) {
            // just add to current
            matrix[currentRow].push(cell);
            currentCol++;
            continue;
          }

          // switch to next row
          currentRow++;
          if (rowsN && currentRow === rowsN) {
            // no more space allowed
            break;
          }

          matrix[currentRow] = [cell];
          currentCol = 1;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return matrix;
    },
    hasSpace: function hasSpace() {
      if (!this.rowsN) {
        return true;
      }
      var rowsN = this.matrix.length;
      return rowsN < this.rowsN || rowsN === this.rowsN && this.matrix[rowsN - 1].length < this.colsN;
    },
    getCell: function getCell(_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          row = _ref4[0],
          col = _ref4[1];

      return this.matrix[row] && this.isAlive(this.matrix[row][col]) ? Number(this.matrix[row][col]) : undefined;
    },
    isAlive: function isAlive(cell) {
      return !!cell || cell === 0;
    },
    isCell: function isCell(_ref5) {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
          row = _ref6[0],
          col = _ref6[1];

      return this.isAlive(this.getCell([row, col])) || false;
    },
    isChainable: function isChainable(coord) {
      if (!this.chained.length) {
        // first one is always chainable
        return true;
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.chained), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref7 = _step4.value;

          var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);

          var chRow = _ref8[0];
          var chCol = _ref8[1];

          if (this.isChainablePair(coord, [chRow, chCol])) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    isChainablePair: function isChainablePair(_ref9, _ref10) {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
          row1 = _ref12[0],
          col1 = _ref12[1];

      var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref10, 2),
          row2 = _ref11[0],
          col2 = _ref11[1];

      if (row1 === row2 && col1 === col2) {
        // we can't chain a cell to itself
        return false;
      }

      // we expect every cell is chainable to another if they both share a "clean path",
      // meaning, there are no other cells left between two of them
      // and path may go as long as needed horizontally, vertically or diagonally (at 45° exactly)
      if (row1 === row2) {
        // check every other col between two
        var col = Math.min(col1, col2) + 1;
        for (; col < Math.max(col1, col2); col++) {
          if (this.isCell([row1, col])) {
            return false;
          }
        }
        return true;
      }

      if (col1 === col2) {
        // almost the same thing
        var row = Math.min(row1, row2) + 1;
        for (; row < Math.max(row1, row2); row++) {
          if (this.isCell([row, col1])) {
            return false;
          }
        }
        return true;
      }

      // ok, let's try the hardest case
      if (Math.abs(row1 - row2) === Math.abs(col1 - col2)) {
        // confirmed on being on the same diagonal
        var rowSign = row1 < row2 ? 1 : -1;
        var colSign = col1 < col2 ? 1 : -1;
        var _row2 = row1 + 1 * rowSign;
        var _col = col1 + 1 * colSign;
        for (; rowSign > 0 && _row2 < row2 || rowSign < 0 && _row2 > row2; _row2 += rowSign, _col += colSign) {
          if (this.isCell([_row2, _col])) {
            return false;
          }
        }
        return true;
      }

      return false;
    },
    isChained: function isChained(coord) {
      return this.chained.some(this._chainedMatcher(coord));
    },
    isCleared: function isCleared(_ref13) {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
          row = _ref14[0],
          col = _ref14[1];

      var rowsN = this.matrix.length;
      return row + 1 < rowsN || row + 1 === rowsN && col < this.matrix[row].length;
    },
    _chainedMatcher: function _chainedMatcher(_ref15) {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref15, 2),
          row = _ref16[0],
          col = _ref16[1];

      return function (_ref17) {
        var _ref18 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref17, 2),
            chRow = _ref18[0],
            chCol = _ref18[1];

        return chRow === row && chCol === col;
      };
    }
  }
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(36);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(85),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-985da41c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(86),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9e54515e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 84:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('span', {
    attrs: {
      "id": "logo"
    }
  }, [_vm._v("√1Ⓡи$")]), _vm._v(" "), _c('h1', [_vm._v("Virus: The Game")]), _vm._v(" "), _c('router-view', {
    attrs: {
      "id": "content"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "matrix-cmp"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('form', {
    staticClass: "options muted"
  }, [_c('strong', [_vm._v("Options:")]), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shouldRemoveEmptyRow),
      expression: "shouldRemoveEmptyRow"
    }],
    attrs: {
      "type": "checkbox",
      "id": "shouldRemoveEmptyRow"
    },
    domProps: {
      "checked": Array.isArray(_vm.shouldRemoveEmptyRow) ? _vm._i(_vm.shouldRemoveEmptyRow, null) > -1 : (_vm.shouldRemoveEmptyRow)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.shouldRemoveEmptyRow,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.shouldRemoveEmptyRow = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.shouldRemoveEmptyRow = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.shouldRemoveEmptyRow = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "shouldRemoveEmptyRow"
    }
  }, [_vm._v("Remove Empty Row(s)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shouldStartWithRandoms),
      expression: "shouldStartWithRandoms"
    }],
    attrs: {
      "type": "checkbox",
      "id": "shouldStartWithRandoms"
    },
    domProps: {
      "checked": Array.isArray(_vm.shouldStartWithRandoms) ? _vm._i(_vm.shouldStartWithRandoms, null) > -1 : (_vm.shouldStartWithRandoms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.shouldStartWithRandoms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.shouldStartWithRandoms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.shouldStartWithRandoms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.shouldStartWithRandoms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "shouldStartWithRandoms"
    }
  }, [_vm._v("Start with Random Sequence")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "option"
  }, [_vm._v("\n        Max Rows:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rowsN),
      expression: "rowsN",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "rowsN-16",
      "value": "16"
    },
    domProps: {
      "checked": _vm._q(_vm.rowsN, _vm._n("16"))
    },
    on: {
      "__c": function($event) {
        _vm.rowsN = _vm._n("16")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rowsN-16"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rowsN),
      expression: "rowsN",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "rowsN-32",
      "value": "32"
    },
    domProps: {
      "checked": _vm._q(_vm.rowsN, _vm._n("32"))
    },
    on: {
      "__c": function($event) {
        _vm.rowsN = _vm._n("32")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rowsN-32"
    }
  }, [_vm._v("32")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rowsN),
      expression: "rowsN",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "rowsN-0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.rowsN, _vm._n("0"))
    },
    on: {
      "__c": function($event) {
        _vm.rowsN = _vm._n("0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rowsN-0"
    }
  }, [_vm._v("∞")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onRestart($event)
      }
    }
  }, [_vm._v("Restart")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onNext($event)
      }
    }
  }, [_vm._v("Next round")])]), _vm._v(" "), _c('dl', {
    staticClass: "info muted"
  }, [_c('dt', [_vm._v("Sequence length:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(this.curSequence.length))]), _vm._v(" "), _c('dt', [_vm._v("Rows number:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.matrix.length))]), _vm._v(" "), _c('dt', [_vm._v("Max Size:")]), _vm._v(" "), (_vm.rowsN) ? _c('dd', [_vm._v(_vm._s(_vm.colsN) + "×" + _vm._s(_vm.rowsN))]) : _c('dd', [_vm._v("unlim")])])]), _vm._v(" "), _c('article', {
    staticClass: "matrix"
  }, _vm._l((_vm.matrix), function(m, row) {
    return _c('div', {
      key: row,
      staticClass: "row"
    }, _vm._l((_vm.colsN), function(col) {
      return _c('div', {
        key: col,
        class: ['cell', _vm.clsCell([row, col - 1])],
        on: {
          "click": function($event) {
            _vm.onChoose([row, col - 1])
          }
        }
      }, [(_vm.isCell([row, col - 1])) ? _c('span', {
        staticClass: "symbol digit"
      }, [_vm._v("\n          " + _vm._s(_vm.getCell([row, col - 1])) + "\n        ")]) : (_vm.isCleared([row, col - 1])) ? _c('span', {
        staticClass: "symbol cleared"
      }, [_vm._v("\n          •\n        ")]) : _vm._e()])
    }))
  })), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "guidelines muted"
  }, [_c('dl', [_c('dt', [_vm._v("Goal:")]), _vm._v(" "), _c('dd', [_vm._v("You need to clear up all INFECTED cells")]), _vm._v(" "), _c('dt', [_vm._v("Next Round:")]), _vm._v(" "), _c('dd', [_vm._v("It just DUPLICATES current strain")])]), _vm._v(" "), _c('h3', [_vm._v("You can neutralize TWO infected cells by these RULES:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("They both should be on the same VERTICAL, HORIZONTAL or DIAGONAL,")]), _vm._v(" "), _c('li', [_vm._v("They both should be VISIBLE to each other,")]), _vm._v(" "), _c('li', [_vm._v("They both should have the SAME VALUE or make a SUM OF 10.")])])])
}]}

/***/ })

},[41]);


// WEBPACK FOOTER //
// static/js/app.3c5e2415d06d0c6955f2.js